import { render, staticRenderFns } from "./DetalhesPerdaDeQualificacaoOscip.vue?vue&type=template&id=e901b762"
import script from "./DetalhesPerdaDeQualificacaoOscip.vue?vue&type=script&lang=ts"
export * from "./DetalhesPerdaDeQualificacaoOscip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports